import React from "react";
import { HexColor } from "@pepdirect/shared/types";
import { colors } from "../../styles/variables";

interface CheckIconSvgProps {
  color?: HexColor;
  width?: string;
  height?: string;
}

export const CheckIconSvg = ({ color, width, height }: CheckIconSvgProps) => (
  <svg
    width={width || "18"}
    height={height || "14"}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00002 11.2L1.80002 6.99998L0.400024 8.39998L6.00002 14L18 1.99998L16.6 0.599976L6.00002 11.2Z"
      fill={color || colors.green}
    />
  </svg>
);
